import { Typography } from "@mui/material";
import { ArrayFieldItemTemplateProps } from "@rjsf/utils";
import React from "react";

export function CustomArrayFieldItemTemplate(props: ArrayFieldItemTemplateProps) {
  const Default = props.registry.templates.ArrayFieldItemTemplate;

  return (
    <>
      <Typography variant="h6" gutterBottom>
        Dependent {props.index + 1}
      </Typography>
      <Default {...props} />
    </>
  );
}
